import { createApp } from 'vue'
import App from './App.vue'
import { MotionPlugin } from '@vueuse/motion'
import './styles/global.scss'
import './styles/text.scss'

const app = createApp(App)
app.use(MotionPlugin).mount('#app')
